import classNames from 'classnames';
import React from 'react';
import { FunctionComponent } from 'react';
import styles from './AverageDonationBanner.scss';
import { useAverageDonation } from '../../hooks/useAverageDonation';
import { useFlags, usePageMeta } from '../../hooks';
import { buildQueryString } from '../../utils/buildQueryString';
import { useTranslation } from 'react-i18next';

type AverageDonationProps = {
  experiments?: string[];
  successType?: string;
};

const AverageDonationBanner: FunctionComponent<AverageDonationProps> = ({
  experiments,
  successType,
}) => {
  const averageDonation = useAverageDonation();
  const { t } = useTranslation('common', { useSuspense: false });
  const { currentUrl } = usePageMeta();
  const { showAverageDonationBanner } = useFlags();

  const urlParams = new URLSearchParams(window.location.search);
  const queryString = buildQueryString(
    experiments,
    successType,
    true,
    urlParams,
  );
  const donateUrl = `${currentUrl}/donate${queryString}`;
  const showBanner = averageDonation > 0 && showAverageDonationBanner;

  return showBanner ? (
    <div
      className={classNames(
        `${styles.averageDonationBanner} jg-display-flex jg-flex-aic jg-space-psm jg-space-mvsm jg-background--white`,
      )}
    >
      <span className={`${styles.donateIcon} jg-space-mrsm`} />
      <div>
        {t('supporters.averageDonation')}
        <strong className={styles.averageDonationAmount}>
          £{averageDonation}
          {'. '}
        </strong>
        <a href={donateUrl}> Give Now</a>
      </div>
    </div>
  ) : null;
};

export default AverageDonationBanner;
